import { observer } from 'mobx-react-lite'
import { StyleSheet, Text, View } from 'react-native'
import { useStore } from '../../../models'
import { color, fontFamily } from '../../../theme'
import { PlayerAvatar } from '../PlayerAvatar'
import { useResponsive } from '@/screens/new-design/hooks'

type SeatedObserverProps = {
  name: string
  id: string
  showVideo?: boolean
}
export const SeatedObserver = ({ name, id, showVideo = false }: SeatedObserverProps) => {
  const { verticalScale } = useResponsive()
  return (
    <View style={styles.container}>
      <PlayerAvatar
        name={name}
        size={3}
        video={showVideo ? { playerId: Number(id) } : undefined}
        color={'Shades/Maroon 2'}
        invert
      />
      <Text allowFontScaling={false} style={[styles.text, styles.name, { fontSize: verticalScale(12) }]}>
        {name}
      </Text>
      <Text allowFontScaling={false} style={[styles.text, styles.observer, { fontSize: verticalScale(10) }]}>
        Teacher
      </Text>
    </View>
  )
}

export const SeatedObserverContainer = observer(() => {
  const {
    communication: { getIsPlayerOnAVCall, playerAVStatus },
    game: { seatedObserver, myPlayer }
  } = useStore()

  if (!seatedObserver) return null

  const amISeatedObserver = seatedObserver.id === myPlayer?.id
  const showVideo =
    !amISeatedObserver && getIsPlayerOnAVCall(seatedObserver) && playerAVStatus(seatedObserver)?.isPlayerOnVideoCall

  return <SeatedObserver name={seatedObserver?.name} id={seatedObserver.id} showVideo={showVideo} />
})

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    alignItems: 'center'
  },
  text: {
    fontFamily: fontFamily.GTAmericaExtendedMedium,
    textAlign: 'center'
  },
  name: {
    color: color.palette.cream,
    fontSize: 12,
    fontWeight: 'bold'
  },
  observer: {
    color: color.palette.lightGrey,
    textTransform: 'uppercase',
    fontSize: 10
  }
})
